import React, { useState, useEffect, useRef } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, ButtonToolbar, Container } from "reactstrap";
import Button from "@material-ui/core/Button";
import { Tooltip, Typography } from "@material-ui/core";
import PropertyCard from "./../reportviews/propertycompreport/components/PropertyCard";
import { ButtonGroup } from "@material-ui/core";
import { calculateAverages, getDerived, formatPropertyData, roundUpToNearest } from "./utils";
import InfoIcon from "mdi-react/InformationIcon";
import Slider from "react-slick";
import ArrowRightIcon from 'mdi-react/ArrowRightDropCircleIcon';
import ArrowLeftIcon from 'mdi-react/ArrowLeftDropCircleIcon';
import BuildingSearchAppBar from '../../../../shared/components/building_filters/UnitsSearchAppBar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LinearLoading from "../../../../shared/components/LinearLoading";
import TargetIcon from "mdi-react/TargetIcon";
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import {
  _isHouse,
  _formatPrice,
  _formatNumber,
  setLocalStorage,
  getLocalStorage,
  syncURLFilters,
  _objectEqual,
  _tranformTagsQuery,
  _capitalizeText,
  _validStrTags,
  _nameToUrl,
  _urlToName,
  recentCohortQuery,
  _validUnitSources,
  _formatUnitNumber
} from "../../../../shared/helpers/utils";
import { 
	_buildingStageFilter,
	_unitStageFilter
} from "../../../../shared/helpers/filters";
import { _axiosCall } from '../../../../shared/helpers/apicalls';
let lsPre = "COMP1_";
const subFilterKey = 'subFilters';
const unitStagesKey = 'unitStages';
const buildingStagesKey = 'buildingStages';

const defaultUnitStage = ["all"];
const defaultStage = ["all"];
 const defaultSubFilter = {property_type : ["residential"]}
function usePrevious(value) {
  const ref = React.useRef();
  useEffect(() => {
	ref.current = value;
  });
  return ref.current;
}
const today = new Date();
const current_year = today.getFullYear();

const useStyles = makeStyles({
  checkbox: {
	color: '#9600BF',
	'&.Mui-checked': {
	  color: '#9600BF',
	},
	'&.Mui-disabled': {
	  color: '#ccc',
	},
  },
  label: {
	fontWeight: 'bold',
	color: '#222 !important',
	'&.Mui-disabled': {
	  color: '#aaa !important',
	},
  },
});

export const _compFilters = [
	{
		name: "Status",
		show_name: true,
		search_key: "current_status",
		multi_filter: true,
		hide_analysis:true,
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			
			{
				name: "Active",
				filter: "active",
				dropdown_name: "Active",
				search_value: "(active)"
			},
			
			{
				name: "In Contract",
				filter: "in-contract",
				dropdown_name: "In Contract",
				search_value: "(*contract* OR *pending*)"
			},
			{
				name: "Sold",
				filter: "closed",
				dropdown_name: "Closed",
				search_value: "(not_yet_recorded OR *sold* OR closed OR resale) OR (offering_status:sold not_yet_recorded OR transfer) OR (current_status:shadow AND offering_submitted_date:[* TO 2010-11-01T00:00:00Z])"
			}
		]
	},
	{
		name: "Ownership",
		show_name: true,
		search_key: "ownership_type",
		multi_filter:true,
		hide_building:true,
		no_key:true,
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Condo",
				filter: "condo",
				dropdown_name: "Condo",
				search_value: "ownership_type:(*condo* !condo*p)",
			},
			{
				name: "Co-op",
				filter: "coop",
				dropdown_name: "Co-op",
				search_value: "ownership_type:(*co?op* *coop* !condo*p)",
			},			
			{
				name: "Condop",
				filter: "condop",
				dropdown_name: "Condop",
				search_value: "ownership_type:(condop*)",
			},	
			{
				name: "Single-Family",
				filter: "single-family",
				dropdown_name: "Single-Family",
				search_value: "ownership_type:single?family",
			},			
			{
				name: "Multi-Family",
				filter: "multi-family",
				dropdown_name: "Multi-Family",
				search_value: "(ownership_type:multi?family OR (ownership_type:rental AND total_units:[* TO 3]))",
			}
			
		]
	},
	
	{
		name: "Asking Price",
		show_name: true,
		search_key: ["min_price", "max_price"],
		filter_key : "asking_price",
		price_filter: true,
		search_value: ['last_listed_sale_price_all:[{min_price} TO {max_price}]']		
	},
	{
		name: "Asking PPSF",
		show_name: true,
		search_key: ["min_ppsf_price", "max_ppsf_price"],
		filter_key : "asking_ppsf",
		price_filter: true,
		target: 'fq',
		labels : ["Min PPSF", "Max PPSF"],
		min_max_values : [500, 4500],
		min_max_increment : 500,
		format_type : "number",
		search_value: ['{!frange l={min_ppsf_price} u={max_ppsf_price}}div(last_listed_sale_price_all,sq_ft)'],
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< $750 PPSF ",
				filter: "less-than-750",
				dropdown_name: "Less than $750",
				search_value: "{!frange l=100 u=750}div(last_listed_sale_price_all,sq_ft)"
			},
			{
				name: "$750 to $1,000 PPSF",
				filter: "75-to-1000",
				dropdown_name: "$750 to $1,000",
				search_value: "{!frange l=751 u=1000}div(last_listed_sale_price_all,sq_ft)"
			},
			{
				name: "$1,000 to $1,500 PPSF",
				filter: "1000-to-1500",
				dropdown_name: "$1,000 to $1,500",
				search_value: "{!frange l=1000 u=1500}div(last_listed_sale_price_all,sq_ft)"
			},
			{
				name: "$1,500 to $2,000 PPSF",
				filter: "1500-to-2000",
				dropdown_name: "$1,500 to $2,000",
				search_value: "{!frange l=1500 u=2000}div(last_listed_sale_price_all,sq_ft)"
			},
			{
				name: "$2,000 to $2,500 PPSF",
				filter: "2000-to-2500",
				dropdown_name: "$2,000 to $2,500",
				search_value: "{!frange l=2000 u=2500}div(last_listed_sale_price_all,sq_ft)"
			},
			{
				name: "$2,500 to $5,000 PPSF",
				filter: "2500-to-5000",
				dropdown_name: "$2,500 to $5,000",
				search_value: "{!frange l=2500 u=5000}div(last_listed_sale_price_all,sq_ft)"
			},
			{
				name: "$5,000+ PPSF",
				filter: "5000-or-more",
				dropdown_name: "$5,000 or more",
				search_value: "{!frange l=5000 u=99999}div(last_listed_sale_price_all,sq_ft)"
			}
		]
	},
	{
		name: "Bedrooms",
		show_name: true,
		search_key: "bedrooms",
		multi_filter: true,
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Studio",
				filter: "studio",
				dropdown_name: "Studio",
				search_value: "0",
			},
			{
				name: "1 Bedroom",
				filter: "1-bedroom",
				dropdown_name: "1 Bedroom",
				search_value: "1",
			},
			{
				name: "2 Bedroom",
				filter: "2-bedroom",
				dropdown_name: "2 Bedroom",
				search_value: "2",
			},
			{
				name: "3 Bedroom",
				filter: "3-bedroom",
				dropdown_name: "3 Bedroom",
				search_value: "3",
			},
			{
				name: "4+ Bedroom",
				filter: "4-or-more",
				dropdown_name: "4+ Bedroom",
				search_value: "[4 TO *]",
			},
		]
	},
	{
		name: "Amenities",
		show_name: true,
		search_key: "building_features",
		autocomplete: true,
		core_name: "we3-properties",
		fq: ["deleted:false"],
		group_amenities: true,
		hide_building:true,
	},
	
	{
		name: "Unit Number",
		show_name: true,
		search_key: "address_2_normalized",
		autocomplete: true,
		core_name: "we3-properties",
		fq: ["deleted:false", `baths:[1 TO *] AND (verification_source:(${_validUnitSources}) OR current_status:(active "in contract"))`],
		group_amenities: false,
		title: "Filter by Unit Number",
		filter_match_operator: "OR",
		min_count: 1,
		hide_operator: true,
		minWidth:220,
		formatter: _formatUnitNumber,
		subtitle: "Filter units in this building that match your search"
		//text_filter: true
	},
	{
		name: "Unit Type",
		show_name: true,
		search_key: "property_type",
		multi_filter: true,
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "Residential",
				filter: "residential",
				dropdown_name: "Residential Units",
				search_value: "(*residential*condo* condo *co-op* \"condo unit\" \"resident manager unit\" *coop* *affordable* \"\" *dwelling* *timeshare* *residential* *apartment* *family*)"
			},
			{
				name: "Commercial",
				filter: "commercial",
				dropdown_name: "Commercial Units",
				search_value: "(*commercial* *office* *retail*)"
			},
			{
				name: "Storage",
				filter: "storage",
				dropdown_name: "Storage Units",
				search_value: "(*storage*)"
			},
			{
				name: "Parking",
				filter: "parking",
				dropdown_name: "Parking",
				search_value: "(*parking* *garage*)"
			},
			{
				name: "Amenities",
				filter: "amenities",
				dropdown_name: "Amenities",
				search_value: "(*gym* *common* *lobby* *pool* *entertainment*)"
			}
		]
	},
	{
		name: "Baths",
		show_name: true,
		search_key: "baths",
		multi_filter: true,
		values: [
			{
				name: "Any",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},			
			{
				name: "1 Bath",
				filter: "1-bath",
				dropdown_name: "1 Bath",
				search_value: "1 OR baths:1",
			},
			{
				name: "2 Bath",
				filter: "2-bath",
				dropdown_name: "2 Bath",
				search_value: "2 OR baths:2",
			},
			{
				name: "3 Bath",
				filter: "3-bath",
				dropdown_name: "3 Bath",
				search_value: "3 OR baths:3",
			},
			{
				name: "4+ Bath",
				filter: "4-or-more",
				dropdown_name: "4+ Bath",
				search_value: "[4 TO *] OR baths:[4 TO *]",
			},
		]
	},

	{
		name: "Interior SF",
		show_name: true,
		search_key: ["min_sq_ft", "max_sq_ft"],
		filter_key : "sq_ft",
		price_filter: true,
		labels : ["Min Sq Ft", "Max Sq Ft"],
		min_max_values : [500, 4500],
		min_max_increment : 500,
		format_type : "number",
		search_value: ['sq_ft:[{min_sq_ft} TO {max_sq_ft}]'], 
		value_prefix : "",
		title_suffix : "SF",
		values: [
			{
				name: "Any Units",
				filter: "",
				dropdown_name: "Any",
				search_value: ""
			},
			{
				name: "< 500 ",
				filter: "less-than-500",
				dropdown_name: "Less than 500 SF",
				search_value: "[10 TO 500] OR sq_ft:[10 TO 500] "
			},
			{
				name: "501 to 750 SF",
				filter: "501-to-750",
				dropdown_name: "501 to 750 SF",
				search_value: "[501 TO 750] OR sq_ft:[501 TO 750] "
			},
			{
				name: "751 to 1,000 SF",
				filter: "751-to-1000",
				dropdown_name: "751 to 1000 SF",
				search_value: "[751 TO 1000] OR sq_ft:[751 TO 1000]"
			},
			{
				name: "1,001 to 1,500 SF",
				filter: "1001-to-1500",
				dropdown_name: "1,001 to 1,500 SF",
				search_value: "[1001 TO 1500] OR sq_ft:[1001 TO 1500]"
			},
			{
				name: "1,501 to 2,000 SF",
				filter: "1501-to-2000",
				dropdown_name: "1,501 to 2,000 SF",
				search_value: "[1501 TO 2000] OR sq_ft:[1501 TO 2000]"
			},
			{
				name: "2,001 to 3,000 SF",
				filter: "2001-to-3000",
				dropdown_name: "2,001 to 3,000 SF",
				search_value: "[2001 TO 3000] OR sq_ft:[2001 TO 3000]"
			},
			{
				name: "3,000+ SF",
				filter: "3001-or-more",
				dropdown_name: "More than 3000 SF",
				search_value: "[3001 TO *] OR sq_ft:[3001 TO *]"
			}
		]
	},
	{
		name: "Floor",
		show_name: true,
		search_key: ["min_floor", "max_floor"],
		filter_key : "floor",
		price_filter: true,
		// target: 'fq',
		labels : ["Min Floor", "Max Floor"],

		custom_min_max_values : {
			"min" : [1, 11, 21, 31, 41],
			"max" : [10, 20, 30, 40, 50, "No Max"]

		},	
		no_max:true,
		format_type : "number",
		search_value: ['floor:[{min_floor} TO {max_floor}]']		,
		format_type : "number",
		value_prefix : "",	
		
		
	},
	{
		name: "Sold Price",
		show_name: true,
		search_key: ["min_sold_price", "max_sold_price"],
		filter_key : "sold_price",
		price_filter: true,
		search_value: ['last_sold_price:[{min_sold_price} TO {max_sold_price}]']		
	},
	{
		name: "Sold Date",
		show_name: true,
		filter_key: "sold_date",
		search_key: ["min_date", "max_date"],
		date_filter: true,
		search_value: ['last_sold_date_formatted:[{min_date} TO {max_date}]']		
	},
	{
		name: "Sold PPSF",
		show_name: true,
		search_key: ["min_sold_ppsf_price", "max_sold_ppsf_price"],
		filter_key : "sold_ppsf",
		price_filter: true,
		target: 'fq',
		labels : ["Min PPSF", "Max PPSF"],
		min_max_values : [500, 4500],
		min_max_increment : 500,
		format_type : "number",
		search_value: ['{!frange l={min_sold_ppsf_price} u={max_sold_ppsf_price}}div(last_sold_price,sq_ft)']
	},
	{
		name: "Contract Date",
		show_name: true,
		filter_key: "contract_date",
		search_key: ["min_contract_date", "max_contract_date"],
		date_filter: true,
		search_value: ['last_contract_date_formatted:[{min_contract_date} TO {max_contract_date}]']		
	},	
	
	{
		name: "Year Built",
		show_name: true,
		exclude_stage: ["pipeline"],
		format_type : "number",
		search_key: ["min_year_built", "max_year_built"],
		filter_key : "year_built",
		price_filter: true,
		labels : ["Min Year Built", "Max Year Built"],
		min_max_values : [1900, current_year],
		min_max_increment : 10,
		custom_min_max_values : {
			"min" : [1900, 1910, 1920, 1930, 1940, 1950, 1960, 1970, 1980, 1990, 2000, 2010, 2020],
			"max" : [1910, 1920, 1930, 1940, 1950, 1960, 1970, 1980, 1990, 2000, 2010, 2020, current_year]
		},		
		format_type : "year",
		search_value: ['year_built:[{min_year_built} TO {max_year_built}]'], 
		value_prefix : "",	
		title_suffix : ""
	}
	
];
export function getCompFilters(isActive, isBuilding, filterQ) {
	const filters = [..._compFilters]; // shallow clone

	// Identify indices
	const ownershipIdx = filters.findIndex(f => f.name === "Ownership");
	const unitNumberIdx = filters.findIndex(f => f.name === "Unit Number");

	// Filter blocks to move
	const askingFields = ["Asking Price", "Asking PPSF"];
	const soldFields = ["Sold Price", "Sold PPSF", "Sold Date"];

	const askingFilters = filters.filter(f => askingFields.includes(f.name));
	const soldFilters = filters.filter(f => soldFields.includes(f.name));

	// Remove them and unit number from the list
	const remainingFilters = filters.filter(f =>
		!askingFields.includes(f.name) &&
		!soldFields.includes(f.name) &&
		f.name !== "Unit Number"
	);

	// Insert asking/sold filters after ownership
	const insertIdx = remainingFilters.findIndex(f => f.name === "Ownership") + 1;
	let reorderedFilters = [
		...remainingFilters.slice(0, insertIdx),
		...(isActive ? askingFilters : soldFilters),
		...remainingFilters.slice(insertIdx)
	];

	// If isBuilding is a non-empty array, modify and move the Unit Number filter
	if (Array.isArray(isBuilding) && isBuilding.length > 0 && unitNumberIdx !== -1) {
		const unitNumberFilter = { ...filters[unitNumberIdx] }; // clone to avoid mutation
		const buildingFq = `building:(${isBuilding.join(" ")})`;
		unitNumberFilter.fq = [...(unitNumberFilter.fq || []), buildingFq, filterQ];
		reorderedFilters = [unitNumberFilter, ...reorderedFilters];
	}

	return reorderedFilters;
}


const WritingInProgress = () => {

  const phrases = [
	"Searching Nearby Properties",
	"Reviewing Similarity",
	"Assessing Valuation",
	"Matching Property Features"
  ];
  const [currentPhrase, setCurrentPhrase] = useState(phrases[0]);

  useEffect(() => {
	const intervalId = setInterval(() => {
	  setCurrentPhrase((prevPhrase) => {
		const currentIndex = phrases.indexOf(prevPhrase);
		const nextIndex = (currentIndex + 1) % phrases.length;
		return phrases[nextIndex];
	  });
	}, 1000); // Change phrase every 2 seconds

	return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, [phrases]);

  return (
	<Typography
	  variant="h5"
	  noWrap
	  style={{ textAlign: "center" }}
	>
	  <TargetIcon
		size={32}
		color="#780F9E"
		style={{ marginTop: -5 }}
	  />{" "}
	  {currentPhrase}...
	</Typography>
  );
};

const CompsLoading = () => {
	return (
	  <div
	    className="loading-comps"
		style={{
			height: '100%',
			position: 'relative',
			background: 'rgb(245, 247, 250)',
			paddingLeft: '20%',
			paddingRight: '20%',
			borderRadius: '8px',
			border: '1px solid #D6BAE8',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			paddingBottom:"24px"
			
		  }}
	  >
		<div style={{ width: "100%", margin: "auto" }}>
		  <LinearLoading />
		  <h2
			style={{
			  padding: 50,
			  fontSize: 24,
			  fontWeight: 600,
			  textTransform: "uppercase",
			}}
		  >
			<WritingInProgress />
		  </h2>
		</div>
	  </div>
	);
  };

const hasFieldChanged = (changes, field) => {
	if (!changes[field]) return false;
  
	const { originalValue, newValue } = changes[field];
	if(!originalValue) return false;
	
	return originalValue !== newValue;
  }
const NestedModal = (props) => {
  const { isOpen, toggle, reportData, nestedModalData, setReportData, setSubmit, setAiResponse, setFetchAi, openDetailModal, searchTags, clearTags, addTag } = props;
 
  
  const [pendingSelections, setPendingSelections] = useState([]);
  const [availableComps, setAvailableComps] = useState([]);
  const [compSource, setCompSource] = useState("activeComps");
  const [errorMessage, setErrorMessage] = useState("");
  const [maxSelectable, setMaxSelectable] = useState(3);
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [subFilters, setSubFilters] = useState(defaultSubFilter);
  const [subFilter, setSubFilter] = useState(null);
  const [buildingStages, setBuildingStages] = useState(defaultStage);
  const [unitStages, setUnitStages] = useState(defaultUnitStage);
  const [start, setStart] = useState(0);
  const [compSearchInProgress, setCompSearchInProgress] = useState(false);
  const [updateSuggestedPrice, setUpdateSuggestedPrice] = useState(true);
  const [totalResults, setTotalResults] = useState(false);
  const classes = useStyles();
  
  
  function buildSolrQueryParts(subFilters, filters, isAvailable) {
	let q = "";
	let fq = [];
	let priceQ = {};
	let dateQ = {};
	let replaceKeys = {};
	let dateReplaceKeys = {};
  
	for (let key in subFilters) {
	  let val = subFilters[key];
	  if (!val || val.length === 0) continue;
  
	  let filter = null;
	  for (let i = 0; i < filters.length; i++) {
		let f = filters[i];
		if (f.search_key === key || (Array.isArray(f.search_key) && f.search_key.indexOf(key) >= 0)) {
		  filter = f;
		  break;
		}
	  }
	  if (!filter) continue;
  
	  // multi_filter
	  if (filter.multi_filter) {
		let values = [];
		for (let j = 0; j < filter.values.length; j++) {
		  if (val.indexOf(filter.values[j].filter) >= 0) {
			values.push(filter.values[j].search_value);
		  }
		}
		if (values.length > 0) {
			if(filter.no_key){
				q += (q ? " AND " : "") + "(" + values.join(" OR ") + ")";
			}else{
				q += (q ? " AND " : "") + "(" + key + ":(" + values.join(" ") + "))";
			}
		 
		}
  
	  // autocomplete
	  } else if (filter.autocomplete) {
		let terms = Array.isArray(val) ? val : [val];
		let operator = "AND";
		let queryTerms = [];
		for (let t = 0; t < terms.length; t++) {
		  let term = terms[t];
		  if (term.indexOf("~") >= 0) {
			let parts = term.split("~");
			operator = parts[1];
			term = parts[0];
		  }
		  let cleaned = term.replace(/[^a-zA-Z0-9]/g, "*");
		  queryTerms.push("*" + cleaned + "*");
		}
		q += (q ? " AND " : "") + "(" + key + ":(" + queryTerms.join(" " + operator + " ") + "))";
  
	  // text_filter
	  } else if (filter.text_filter) {
		let terms = typeof val === "string" ? val.split(" ") : val;
		let fields = filter.search_fields || [key];
		let blocks = [];
		for (let x = 0; x < terms.length; x++) {
		  let term = terms[x];
		  let clause = [];
		  for (let y = 0; y < fields.length; y++) {
			clause.push(fields[y] + ":(*" + term.toLowerCase() + "* *" + term.toUpperCase() + "* *" + _capitalizeText(term) + "* *" + term + "*)");
		  }
		  blocks.push("(" + clause.join(" OR ") + ")");
		}
		q += (q ? " AND " : "") + "(" + blocks.join(" AND ") + ")";
	  }
  
	  // price_filter
	  if (filter.price_filter) {
		let fk = filter.filter_key;
  
		// Ensure full key list is captured regardless of presence in subFilters
		if (!replaceKeys[fk]) {
		  replaceKeys[fk] = Array.isArray(filter.search_key) ? filter.search_key.slice() : [filter.search_key];
		}
  
		let template = filter.search_value && filter.search_value[0] || "";
		priceQ[fk] = priceQ[fk] || template;
  
		let regex = new RegExp("{" + key + "}", "g");
		priceQ[fk] = priceQ[fk].replace(regex, val);
	  }
  
	  // date_filter
	  if (filter.date_filter) {
		let dfk = filter.filter_key;
  
		if (!dateReplaceKeys[dfk]) {
		  dateReplaceKeys[dfk] = Array.isArray(filter.search_key) ? filter.search_key.slice() : [filter.search_key];
		}
  
		let dTemplate = filter.search_value && filter.search_value[0] || "";
		let iso = new Date(val).toISOString();
		dateQ[dfk] = dateQ[dfk] || dTemplate;
		let dRegex = new RegExp("{" + key + "}", "g");
		dateQ[dfk] = dateQ[dfk].replace(dRegex, iso);
	  }
  
	  // basic match
	  if (
		!filter.multi_filter &&
		!filter.autocomplete &&
		!filter.text_filter &&
		!filter.price_filter &&
		!filter.date_filter
	  ) {
		let match = null;
		for (let z = 0; z < (filter.values || []).length; z++) {
		  if (filter.values[z].filter === val) {
			match = filter.values[z];
			break;
		  }
		}
		if (match) {
		  if (filter.target === "fq") {
			fq.push(match.search_value);
		  } else {
			q += (q ? " AND " : "") + "(" + key + ":" + match.search_value + ")";
		  }
		  if (match.additional_fq) {
			fq = fq.concat(match.additional_fq);
		  }
		}
	  }
	}
  
	// finalize price filters
	for (let pk in priceQ) {
	  let clause = priceQ[pk];
	  let keys = replaceKeys[pk] || [];
  
	  for (let k = 0; k < keys.length; k++) {
		let rkey = keys[k];
		let regex = new RegExp("{" + rkey + "}", "g");
		if (clause.indexOf("{" + rkey + "}") >= 0) {
		  let defaultVal = rkey.indexOf("min") >= 0 ? "0" : (pk === "asking_price" ? "99999999" : "*");
		  clause = clause.replace(regex, defaultVal);
		}
	  }
	  q += (q ? " AND " : "") + "(" + clause + ")";
	}
  
	// finalize date filters
	for (let dk in dateQ) {
	  let dClause = dateQ[dk];
	  let dKeys = dateReplaceKeys[dk] || [];
  
	  for (let m = 0; m < dKeys.length; m++) {
		let dKey = dKeys[m];
		let dre = new RegExp("{" + dKey + "}", "g");
		if (dClause.indexOf("{" + dKey + "}") >= 0) {
		  dClause = dClause.replace(dre, "*");
		}
	  }
	  q += (q ? " AND " : "") + "(" + dClause + ")";
	}
  
	return { q: q, fq: fq };
  }

  const handleSearch = async function() {
	//setSearchText(value);
	
	let building = reportData.buildingRes;
	const { selectedUnit } = reportData.compSettings;
	const { subjectProperty } = reportData.derivedData;
    setCompSearchInProgress(true);
	let q = "";
	let fq = ["deleted:false"];
	
	
	const hasBuilding = searchTags.filter(item => item.type === "building").length>0;
	
	if(!hasBuilding){
		if(subjectProperty && !_isHouse(subjectProperty)){
			fq.push(`-address_2_normalized:""`);
		}else if(_isHouse(subjectProperty)){
			fq.push(`address_2_normalized:""`);
		}
		
	}else{
		//fq.push(`(baths:[1 TO *] AND (verification_source:(${_validUnitSources}) OR current_status:(active "in contract"))) OR ownership_type:*family*`);
	}
	
	
	if(subjectProperty && subjectProperty.key){
		fq.push(`-key:${subjectProperty.key}`);
	}
  
	if (searchTags.length > 0) {
	  let locQ = _tranformTagsQuery(searchTags, "building");
	  if (locQ) q += (q ? " AND " : "") + locQ;
	}
  
	let subFilterParts = buildSolrQueryParts(subFilters, _compFilters);
	if (subFilterParts.q) q += (q ? " AND " : "") + subFilterParts.q;
	if (subFilterParts.fq.length > 0) fq = fq.concat(subFilterParts.fq);
	
	
  
	if (unitStages.length > 0 && unitStages.indexOf("all") < 0) {
	  q += (q ? " AND " : "") + 'property_status:("' + unitStages.join('" OR "') + '")';
	  q += ' AND (source_organizations:(NYAG CDEC ADEC) OR (verification_source:(permits rls cofo co opra deed rets mls) OR ownership_type:co*cop) OR current_status:active)';
	}
  
	if (buildingStages.length > 0 && buildingStages.indexOf("all") < 0) {
	  fq.push('{!join from=alternate_keys fromIndex=we3-buildings to=building}building_status:("' + buildingStages.join('" OR "') + '")');
	}
  
	// if (value && value.length > 0) {
	//   let text = value.replace(/ /g, '*').toLowerCase();
	//   let textCaps = _capitalizeText(value.toLowerCase(), false).replace(/ /g, '*');
	//   q += (q ? " AND " : "") + '(building_name:(*' + text + '* OR *' + textCaps + '*) OR display_full_street_address:*' + text + '* OR neighborhood:*' + text + '*)';
	// }
  
	q = q || "*:*";
  
	try {
	  const response = await _axiosCall({
		url: process.env.API_ROOT + "/query/we3-properties",
		method: "post",
		query: {
		  q: q,
		  fq: fq,
		  fl: [
			  "full_street_address",
			  "display_full_street_address",
			  "zip",
			  "address_2",
			  "address_2_normalized",
			  "floor",
			  "current_status",
			  "bedrooms",
			  "baths",
			  "half_baths",
			  "sq_ft",
			  "exterior_sq_ft",
			  "offering_price",
			  "building",
			  "building_name",
			  "neighborhood",
			  "borough",
			  "monthly_fees",
			  "monthly_taxes",
			  "key",
			  "total_units",
			  "residential_units",
			  "last_sold_price",
			  "last_sold_date",
			  "price",
			  "last_listed_sale_price_all",
			  "last_listed_sale_date_all",
			  "last_listed_sale_modified_date_all",
			  "last_listed_sale_ppsf_all",
			  "last_listed_rent_price_all",
			  "last_listed_rent_date_all",
			  "last_contract_date",
			  "last_contract_price",
			  "last_contract_date_formatted",
			  "last_listed_sale_key_all",
			  "last_listed_rent_key_all",
			  "last_listed_sale_status_all",
			  "last_listed_rent_status_all",
			  "id",
			  "div(last_sold_price, sq_ft)",
			  "div(last_listed_sale_price_all, sq_ft)",
			  "div(last_contract_price, sq_ft)",
			  "div(sub(offering_price, last_listed_sale_price_all), offering_price)",
			  "div(sub(offering_price, last_sold_price), offering_price)",
			  "owner",
			  "ownership_type",
			  "borough_code",
			  "block",
			  "lot",
			  "year*",
			  "building_class",
			  "property_features",
			  "building_features",
			  "score",
			  "geodist()"
		  ],
		  rows: 50,
		  wt: 'json',
		  "sfield": "geocode",
		  "pt": building.geocode,
		  "d": 50,
		  "sort": "geodist() asc, last_sold_date desc, last_listed_sale_date_all desc",
		}
	  });
  
	  let results = (response && response.docs) || [];
	  setSearchResults(results);
	  setFilteredResults(results);
	  setTotalResults(response && response.numFound ? response.numFound : false)
	  setCompSearchInProgress(false);
	} catch (err) {
	  console.error("Search failed:", err);
	  setSearchResults([]);
	  setFilteredResults([]);
	  setCompSearchInProgress(false);
	}
  };
  
  const prevSearchTags = usePrevious(searchTags);
  const prevSubFilters = usePrevious(subFilters);
  const prevUnitStages = usePrevious(unitStages);
  const prevBuildingStages = usePrevious(buildingStages);
  const prevSearchText = usePrevious(searchText);
  const suppressSearch = useRef(false);

  useEffect(() => {
	if (!isOpen || !prevSearchTags || suppressSearch.current) return;

  
	const subFilterChanged = _compFilters.filter(item => {
	  if (Array.isArray(item.search_key)) {
		return item.search_key.some(key => prevSubFilters[key] !== subFilters[key]);
	  }
	  return prevSubFilters[item.search_key] !== subFilters[item.search_key];
	}).length > 0;
  
	const searchTagsChange = !_objectEqual(prevSearchTags, searchTags);
	const unitStageChange = !_objectEqual(prevUnitStages, unitStages);
	const buildingStageChange = !_objectEqual(prevBuildingStages, buildingStages);
	const searchTextChange = prevSearchText !== searchText;
  
	if (
	  searchTagsChange ||
	  subFilterChanged ||
	  unitStageChange ||
	  buildingStageChange ||
	  searchTextChange
	) {
	  handleSearch();
	}
  }, [isOpen, searchTags, subFilters, unitStages, buildingStages, searchText]);



  
  const handleSubFilters = (theSubFilters) => {
	const subF = Object.assign({}, subFilters, theSubFilters);
  
	setSubFilters(subF);
	setStart(0)
  };
  
  const handleSubFilter = (search_key, search_val) => {
  
	  const subF = Object.assign({}, subFilters, {
			  [search_key]: search_val
		  });
	  
	  setSubFilters(subF);
	  setStart(0);
  }
  
  
  const resetSubFilter = () => {
	
	setSubFilters(defaultSubFilter);
	setBuildingStages(defaultStage);
	setUnitStages(unitStages);
	setStart(0)
  };
  
  const setBuildingStage = (stage) => {
  
	  let newStages = buildingStages.slice();
	  const index = newStages.indexOf(stage);		
	  const indexAll = newStages.indexOf('all');
	  
	  
	  if(index>=0){
		  
		  if(stage === "all"){
			  newStages = this.defaultStage
		  }else{
			  newStages.splice(index, 1);
		  }
	  }else{
		  if(stage === "all"){
			  newStages = ["all"]
		  }else{
			  if(indexAll>=0){
				  newStages.splice(indexAll, 1);
			  }
			  newStages.push(stage)
		  }
		  
	  }
	  
	  if(newStages.length === 0 ) newStages = ['all'];
	  
	  setBuildingStages(newStages);
	  setStart(0);
	  setLocalStorage(lsPre, buildingStagesKey, JSON.stringify(newStages));
  }
  
  const resetActive = () => {
	  
	  
	  
	  let isDefault = true;
	  isDefault = searchTags.length===0 &&
		_objectEqual(defaultSubFilter, subFilters) &&
		_objectEqual(defaultUnitStage, unitStages) &&
		_objectEqual(defaultStage, buildingStages);
	  
		
	  return !isDefault;
	  
  }
  const sliderRef = useRef(null);
  const settings = {
		dots: false,
		infinite: false,
		speed: 500,
		autoplay: false,
		swipeToSlide: true,
		variableWidth: true, // ← key option
		prevArrow: <ArrowLeftIcon size={50} fill="#000" />,
		nextArrow: <ArrowRightIcon  size={50} fill="#000" />,
		// responsive: [
		//   { breakpoint: 768, settings: { slidesToShow: 1 } },
		//   { breakpoint: 992, settings: { slidesToShow: 2 } },
		//   { breakpoint: 1200, settings: { slidesToShow: 3 } },
		//   { breakpoint: 1536, settings: { slidesToShow: 3 } },
		//   { breakpoint: 100000, settings: { slidesToShow: 4 } },
		// ],
	};
//   useEffect(function() {
// 	if (reportData && reportData.derivedData && nestedModalData) {
// 	  
// 
// 	  let pool = isActive ? compResponse.comps.active : compResponse.comps.sold;
// 	  let formatted = [];
// 	  for (let j = 0; j < pool.length; j++) {
// 		formatted.push(source === "activeComps" ? formatPropertyData(pool[j]) : formatPropertyDataSold(pool[j]));
// 	  }
// 	  setAvailableComps(formatted);
// 
// 	  let usedIds = (isActive ? activeComps : soldComps).map(function(c) { return c.id; });
// 	  let initialSelections = nestedModalData.compKey
// 		? usedIds.filter(function(id) { return id !== nestedModalData.compKey; })
// 		: usedIds;
// 	  setPendingSelections(initialSelections);
// 
// 	  const maxAvail = nestedModalData.compKey ? formatted.length - 1 : formatted.length;
// 	  setMaxSelectable(Math.min(3, maxAvail));
// 	}
//   }, [reportData, nestedModalData]);
// 
 //  const hasSelectedBuilding = useRef(false);
 // useEffect(() => {
 //   if (!isOpen) return;
 // 
 //   const buildingTags = searchTags.filter(tag => tag.type === 'building');
 // 
 //   // If user just selected a building for the first time
 //   if (buildingTags.length > 0 && !hasSelectedBuilding.current) {
	//  hasSelectedBuilding.current = true;
 // 
	//  // Remove all other tags and keep only the building one
	//  if (buildingTags.length === 1) {
	//    suppressSearch.current = true;
	//    resetSubFilter();
	//    
	//    
 // 	   suppressSearch.current = false;
	// 	handleSearch(); // Manually run search
	//    
	//  }
 //   }
 // 
 //   // Reset flag when modal closes or all tags are removed
 //   if (buildingTags.length === 0) {
	//  hasSelectedBuilding.current = false;
 //   }
 // }, [searchTags, isOpen]);

 useEffect(function() {
	 if (reportData && reportData.derivedData && searchResults) {
	   
 	   if(!reportData || !reportData.compSettings || !reportData.derivedData || !nestedModalData) return null;
	   let compResponse, isActive, source, activeComps, soldComps;
	   activeComps = reportData.derivedData.activeComps;
	   soldComps = reportData.derivedData.soldComps;
	   compResponse = reportData.compResponse;
	   isActive = false;
	   if(nestedModalData && nestedModalData.compType=="active" || compSource == 'activeComps'){
		   isActive = true;
	   }else{
		   for (let i = 0; i < activeComps.length; i++) {
				if (activeComps[i].id === nestedModalData.compKey) {
				isActive = true;
				break;
				}
		   }
	   }
	   source = isActive ? "activeComps" : "soldComps";
	   // let pool = isActive ? compResponse.comps.active : compResponse.comps.sold;
	   let formatted = [];
	   const baseComps = isActive ? activeComps : soldComps;
 	   // Merge availableComps into sourceComps in case some pendingSelections exist only there
		const seenIds = new Set();
		const sourceComps = [...baseComps, ...(availableComps || [])].filter(item => {
			if (seenIds.has(item.id)) return false;
			seenIds.add(item.id);
			return true;
		});

	   
	   
	   sourceComps.map(function(item) {
		   if (pendingSelections.indexOf(item.id) >= 0) {
			   if (item.tag) {
				   formatted.push(item); // already formatted
			   } else {
				   var f = formatPropertyData(item, false, isActive ? 'active' : 'sold');
				   f._raw = item;
				   formatted.push(f);
			   }
		   }
	   });
	   
	   searchResults.map(function(item) {
		   var exists = false;
		   for (var i = 0; i < formatted.length; i++) {
			   if (formatted[i].id === item.id) {
				   exists = true;
				   break;
			   }
		   }
		   if (!exists) {
			   if (item.tag) {
				   formatted.push(item); // already formatted
			   } else {
				   var f = formatPropertyData(item, false, isActive ? 'active' : 'sold');
				   f._raw = item;
				   formatted.push(f);
			   }
		   }
	   });

	  
	   setAvailableComps(formatted);
 
	   const maxAvail = nestedModalData.compKey ? formatted.length - 1 : formatted.length;
	   //setMaxSelectable(Math.min(3, maxAvail));
	   
	   if (sliderRef.current) {
		 sliderRef.current.slickGoTo(0);
	   }
	 }
   }, [searchResults]);
  
  useEffect(function() {
	  if(isOpen){
		  
	   if(!reportData || !reportData.compSettings || !reportData.derivedData || !nestedModalData) return null;
	   let compResponse, isActive, source, activeComps, soldComps;
	   activeComps = reportData.derivedData.activeComps;
	   soldComps = reportData.derivedData.soldComps;
	   compResponse = reportData.compResponse;
	   isActive = false;
	   
		if(nestedModalData && nestedModalData.compType=="active"){
			isActive = true;
		}else{
			for (let i = 0; i < activeComps.length; i++) {
				 if (activeComps[i].id === nestedModalData.compKey) {
				 isActive = true;
				 break;
				 }
			}
		}
	   source = isActive ? "activeComps" : "soldComps";
		const { propertyDetails } = reportData.compSettings;
   	
		
	 	
	  	
	 	
		const compDefaultFilter = {current_status : isActive ? ["active"] : ["closed"], property_type : ["residential"], bedrooms:[`${propertyDetails.bedrooms > 0 && propertyDetails.bedrooms < 4 ? propertyDetails.bedrooms+"-bedroom" : propertyDetails.bedrooms == 0 ? "studio" : propertyDetails.bedrooms >=4 ? "4-or-more" : null}`]};
		if(!isActive){
			compDefaultFilter['min_sold_price'] = 100000;
			compDefaultFilter['min_date'] = new Date(new Date().setFullYear(new Date().getFullYear() - 3)).toISOString().slice(0, 10);
		}
		//addTag({type:'neighborhood', data: obj, id: id, name: obj.hood}); 
		console.log(compDefaultFilter);
		  clearTags();
		  
		  let building = reportData.buildingRes;
		  const boro = _validStrTags(building.borough);
		  const hood = _validStrTags(building.neighborhood[0]);
		  let urlBoro = boro ? _nameToUrl(boro) : "new-york";
		  let urlHood = hood ? hood : "nyc";
		  const obj = {
			  hood: _urlToName(urlHood.toString()),
			  boro: _urlToName(urlBoro.toString())
			}
		 
		  const id = _nameToUrl(obj.hood + '_' + obj.boro);
		  
		  addTag({type:'neighborhood', data: obj, id: id, name: obj.hood}); 
		  setSubFilters(compDefaultFilter);
		  setCompSource(source);
		  
		  let usedIds = (isActive ? activeComps : soldComps).map(function(c) { return c.id; });
			 let initialSelections = nestedModalData.compKey
			   ? usedIds.filter(function(id) { return id !== nestedModalData.compKey; })
			   : usedIds;
			 setPendingSelections(initialSelections);
			 
		  if(nestedModalData.changes){
			  if (hasFieldChanged(nestedModalData.changes, "suggestedPrice")) {
				console.log("Suggested price was changed");
				setUpdateSuggestedPrice(false);
			  }
		  }
		 // handleSearch();
	  }
  },[isOpen]);

  if (!isOpen || !reportData || !reportData.derivedData) return null;

  const handleSelectComp = function(compId) {
	setFetchAi(false);
	setPendingSelections(function(prev) {
	  if (prev.indexOf(compId) !== -1) {
		return prev.filter(function(id) { return id !== compId; });
	  } else {
		if (prev.length < maxSelectable) {
		  return prev.concat(compId);
		} else {
		  setErrorMessage("Maximum number of comps already selected, you must unselect a comp first.");
		  setTimeout(function() {
			setErrorMessage("");
		  }, 3000);
		  return prev;
		}
	  }
	});
  };

  const handleConfirm = function() {
	  if (pendingSelections.length !== maxSelectable) return;
  
	  var poolActive = reportData.compResponse.comps.active || [];
	  var poolSold = reportData.compResponse.comps.sold || [];
  
	  var foundComps = [];
  
	  for (var i = 0; i < pendingSelections.length; i++) {
		  var id = pendingSelections[i];
		  var found = null;
  
		  // Search active comps
		  for (var j = 0; j < poolActive.length; j++) {
			  if (poolActive[j].id === id) {
				  found = poolActive[j];
				  break;
			  }
		  }
  
		  // Search sold comps
		  if (!found) {
			  for (var k = 0; k < poolSold.length; k++) {
				  if (poolSold[k].id === id) {
					  found = poolSold[k];
					  break;
				  }
			  }
		  }
  
		  // Search searchResults
		  if (!found) {
			  for (var m = 0; m < searchResults.length; m++) {
				  if (searchResults[m].id === id) {
					  found = searchResults[m];
					  break;
				  }
			  }
		  }
  
		  // Search availableComps (check _raw first)
		  if (!found) {
			  for (var n = 0; n < availableComps.length; n++) {
				  var comp = availableComps[n];
				  if (comp._raw && comp._raw.id === id) {
					  found = comp._raw;
					  break;
				  } else if (comp.id === id) {
					  found = comp;
					  break;
				  }
			  }
		  }
  
		  if (found) {
			  foundComps.push(found);
		  }
	  }
  
	  var theReportData = Object.assign({}, reportData);
	  var originalComps = compSource === "activeComps"
		  ? (theReportData.derivedData.activeComps || [])
		  : (theReportData.derivedData.soldComps || []);
  
	  var replacedIndex = -1;
  
	  // Only search for replacement index if compKey is truthy and originalComps not empty
	  if (nestedModalData.compKey && originalComps.length > 0) {
		  for (var z = 0; z < originalComps.length; z++) {
			  if (originalComps[z].id === nestedModalData.compKey) {
				  replacedIndex = z;
				  break;
			  }
		  }
	  }
  
	  // If we have enough found comps, update derivedData
	  if (foundComps.length === maxSelectable) {
		  var newComps = [].concat(foundComps);
  
		  if (replacedIndex !== -1) {
			  // Replace the comp at the found index
			  var replacedComp = newComps.pop();
			  newComps.splice(replacedIndex, 0, replacedComp);
		  }
		  // If nothing to replace, just use the new comps
  
		  if (compSource === "activeComps") {
			  theReportData.derivedData.activeComps = newComps;
		  } else {
			  theReportData.derivedData.soldComps = newComps;
		  }
	  }
  
	  theReportData["updateSuggestedPrice"] = updateSuggestedPrice;

	  if (updateSuggestedPrice) {
		  var allPrices = [];
		  for (var a = 0; a < theReportData.derivedData.activeComps.length; a++) {
			  allPrices.push(theReportData.derivedData.activeComps[a].last_listed_sale_price_all);
		  }
		  for (var b = 0; b < theReportData.derivedData.soldComps.length; b++) {
			  allPrices.push(theReportData.derivedData.soldComps[b].last_sold_price);
		  }

		  if (allPrices.length > 0) {
			  var total = 0;
			  for (var c = 0; c < allPrices.length; c++) {
				  total += allPrices[c];
			  }
			  var suggestedPrice = total / allPrices.length;
			  theReportData.compResponse.suggestedPrice = roundUpToNearest(suggestedPrice);
		  }
	  }

	  var derivedData = getDerived(
		  theReportData,
		  theReportData.derivedData.activeComps,
		  theReportData.derivedData.soldComps
	  );
	  theReportData.derivedData = derivedData;

	  setReportData(theReportData);
	  setAiResponse(null);
	  setFetchAi(true);
	  toggle();
  };


  
  const isBuilding = Array.isArray(searchTags)
	? searchTags.filter(item => item.type === "building").map(item => item.id)
	: [];
  const isActive = compSource == "activeComps";
  
  let filterQ = "";
  let subFilterParts = buildSolrQueryParts(subFilters, _compFilters);
  if (subFilterParts.q) filterQ += (filterQ ? " AND " : "") + subFilterParts.q;
  return (
	<Modal isOpen={isOpen} toggle={toggle} size="lg" className="full_width_modal modal-body-left">
	  <ModalHeader toggle={toggle}>
		<h4 className="contact__title" style={{ textAlign: "left" }}>
		  Select Comparable Properties {isActive ? "On the Market" : "Recently Sold"}
		</h4>
		{/* <p style={{ textTransform: "initial", textAlign: "left", marginBottom: "10px" }}>
		  Choose {maxSelectable} propert{maxSelectable === 1 ? "y" : "ies"} that are most comparable to the subject property.
		</p> */}
	  </ModalHeader>
	  <ModalBody>
	    <div className="comp-selector-filter">
	  		<BuildingSearchAppBar
				handleSearch={handleSearch}
				searchText={searchText}
				setSubFilters={handleSubFilters}
				resetSubFilter={resetSubFilter}
				subFilters={subFilters}
				setSubFilter={handleSubFilter}
				_filters={getCompFilters(isActive, isBuilding, filterQ)}      // pass available filters like borough/neighborhood if needed
				placeHolder="Search by Address, Building, or Neighborhood"
				numToShow={7}
				buildingStages={buildingStages}
				setBuildingStage={setBuildingStage}
				resetActive={resetActive()}
				buildingAttributes={[]}
				hideBuildingStage={true}
				singleTag={true}
		  	/>
	    </div>
		<Container className="dashboard">
		  {errorMessage && (
			<div style={{
			  backgroundColor: "#FFF",
			  border:"1px solid #780F9E",
			  color: "#780F9E",
			  padding: "10px 20px",
			  borderRadius: "4px",
			  marginBottom: "0px",
			  fontSize: "14px",
			  textAlign:"left"
			}}>
			  {errorMessage}
			</div>
		  )}
		  <p style={{ fontSize: "18px", marginTop:"10px", marginBottom: "15px", textAlign: "left", fontWeight:600, display:"flex", alignItems:"center", gap:"5px" }}>
		  	<InfoIcon color={"#780F9E"} /> 
			{pendingSelections.length < maxSelectable
			  ? `Select up to ${maxSelectable} comp${maxSelectable === 1 ? '' : 's'} to continue.`
			  : `${maxSelectable} comp${maxSelectable === 1 ? '' : 's'} selected. Select one to replace or update the report.`}
			{" "}
			{availableComps.length>0 ?
			<>
			
			{totalResults && totalResults > availableComps.length
			  ? ` Showing ${availableComps.length} of ${totalResults > 100 ? "100+" : _formatNumber(totalResults)} properties — refine your search to find the best comps.`
			  : availableComps.length > 3
				? `Showing ${availableComps.length} similar propert${availableComps.length === 1 ? 'y' : 'ies'} — scroll right to view all.`
				: ''}
		     </>:null}

		  </p>
		  <div className="all-comps-container">
			<div className={`property-comparison-container comp-changer ${compSearchInProgress ? " loading" : ""}`}>
			<div className="comp-changer-subject">
			  <PropertyCard
				property={compSource === "activeComps" ? formatPropertyData(reportData.derivedData.subjectProperty, true) : formatPropertyData(reportData.derivedData.subjectProperty, true)}
				index={0}
				isSubject={true}
				showSelectIcon={false}
				compSource={compSource} 
				openDetailModal={openDetailModal}
				avgDOM={reportData && reportData.derivedData && reportData.derivedData.avgDOM ? _formatNumber(reportData.derivedData.avgDOM) : null}
			  />
			</div>
			
			  {compSearchInProgress ? 
				  
				 <div style={{width:"100%"}}><CompsLoading /></div>
				 :
				 <div className="comp-changer-alt">
			  	 <Slider ref={sliderRef} {...settings} className="">
			  		{availableComps.map(function(property, idx) {
						let isSelected = pendingSelections.indexOf(property.id) !== -1;
						let buttonText = isSelected ? "Remove" : "Select";
						let disableSelect = !isSelected && pendingSelections.length >= maxSelectable;
		
						return (
				  		<PropertyCard
							key={property.id}
							property={property}
							index={idx + 1}
							isSubject={false}
							isSelected={isSelected}
							buttonText={buttonText}
							disableSelect={disableSelect}
							onClick={function(e) {
					  		e.preventDefault();
					  		e.stopPropagation();
					  		handleSelectComp(property.id);
							}}
							showSelectIcon={true}
							openDetailModal={openDetailModal}
							compSource={compSource} //
							avgDOM={reportData && reportData.derivedData && reportData.derivedData.avgDOM ? _formatNumber(reportData.derivedData.avgDOM) : null}
				  		/>
						);
			  		})}
			  	</Slider>
				 </div>
		  	}
			
			</div>
		  </div>
		</Container>
	  </ModalBody>
	 <ModalFooter>
		 <ButtonToolbar className="modal__footer mb-3">
		   <FormControlLabel
			  control={
				<Checkbox
				  checked={updateSuggestedPrice}
				  onChange={function(e) { setUpdateSuggestedPrice(e.target.checked); }}
				  className={classes.checkbox}
				  disabled={pendingSelections.length !== maxSelectable}
				/>
			  }
			  label="Update Suggested Price"
			  classes={{ label: classes.label }}
			  className=""
			/>
		   <Tooltip title="Cancel">
			 <Button onClick={toggle} variant="outlined" className="mr-2">
			   Cancel
			 </Button>
		   </Tooltip>
		   <Tooltip title="Reset Selections">
			 <Button
			   onClick={function() { setPendingSelections([]); }}
			   variant="outlined"
			   className="mr-2"
			   disabled={pendingSelections.length === 0}
			 >
			   Remove All Comps
			 </Button>
		   </Tooltip>
		   <Tooltip title="Confirm Selection">
			 <Button
			   onClick={handleConfirm}
			   variant="contained"
			   color="primary"
			   disabled={pendingSelections.length !== maxSelectable}
			 >
			   Update Report ({pendingSelections.length}/{maxSelectable} Comps)
			 </Button>
		   </Tooltip>
		 </ButtonToolbar>
	 </ModalFooter>

	</Modal>
  );
};


const mapStateToProps = (state) => ({
  user: state.user,
  searchTags: Array.isArray(state.search.searchTags)
	? state.search.searchTags.slice()
	: [],
});

export default withRouter(connect(mapStateToProps)(NestedModal));
